import { MapPin, Phone } from "lucide-react";

export default function Footer({ settings }) {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full px-4 py-4" data-testid="site-footer">
      <div
        className="max-w-[640px] mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs"
        style={{ color: "var(--pp-muted)" }}
      >
        <div className="flex flex-col gap-1">
          <span className="flex items-center gap-2" data-testid="footer-address">
            <MapPin className="w-4 h-4" />
            {settings.business_address}
          </span>
          <a
            href={`tel:${settings.business_phone.replace(/[^0-9]/g, "")}`}
            className="flex items-center gap-2 hover:underline"
            style={{ color: "var(--pp-indigo)" }}
            data-testid="footer-phone"
          >
            <Phone className="w-4 h-4" />
            {settings.business_phone}
          </a>
        </div>
        <div data-testid="footer-rights">© {year} {settings.business_name}. All rights reserved.</div>
      </div>
    </footer>
  );
}
